// import React from 'react';

export const links = [
	{
		id: 1,
		url: '/',
		text: 'home',
	},
	{
		id: 2,
		url: '/destination',
		text: 'destination',
	},
	{
		id: 3,
		url: '/blog',
		text: 'blog',
	},
	{
		id: 4,
		url: '/contact',
		text: 'contact',
	},
];

export const transports = [
	{
		id: 1,
		transportsType: 'Bike',
		img: 'images/bike.png',
		speed: 20,
		fair: 12,
	},
	{ id: 2, transportsType: 'Car', img: 'images/car.png', speed: 30, fair: 15 },
	{ id: 3, transportsType: 'Bus', img: 'images/bus.png', speed: 25, fair: 2 },
	{
		id: 4,
		transportsType: 'Train',
		img: 'images/train.png',
		speed: 50,
		fair: 1.5,
	},
];
